import axios from './axios';
import { API_URL as API_BASE } from '../config/env';

const API_URL = `${API_BASE}/api/voucher-status-closures`;

export async function getAllClosureStatuses(settlement_date_id) {
	const token = localStorage.getItem('token');
	const res = await axios.get(API_URL, {
		params: { settlement_date_id },
		headers: token ? { Authorization: `Bearer ${token}` } : {},
	});
	return res.data;
}


export async function getClosureStatus(student_id, settlement_date_id) {
	const token = localStorage.getItem('token');
	const res = await axios.get(API_URL, {
		params: { student_id, settlement_date_id },
		headers: token ? { Authorization: `Bearer ${token}` } : {},
	});
	return res.data;
}


export async function setClosureStatus(student_id, settlement_date_id, status) {
	const token = localStorage.getItem('token');
	const res = await axios.post(API_URL, { student_id, settlement_date_id, status }, {
		headers: token ? { Authorization: `Bearer ${token}` } : {},
	});
	return res.data;
}
